export default "da7dce7829c917b8.svg"